export default "__VITE_ASSET__BEdy9EE___"